import { render, staticRenderFns } from "./OmxList.vue?vue&type=template&id=5b8940b2&scoped=true"
import script from "./OmxList.vue?vue&type=script&lang=js"
export * from "./OmxList.vue?vue&type=script&lang=js"
import style0 from "./OmxList.vue?vue&type=style&index=0&id=5b8940b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8940b2",
  null
  
)

export default component.exports